import { useEffect, useState } from "react";
import { API_HEADERS, extractBaseServerV2, MIDDLEWARE } from "../utils/utils";
import { ENDPOINTS } from "../utils/endpoints";

interface UseAllServicesParams {
  corpId: string;
  recruiterId: string;
  middleware?: string;
  version?: Record<string, string>;
  isUseMasterData?: boolean;
}

export const useAllServices = ({
  corpId,
  recruiterId,
  middleware,
  version,
  isUseMasterData,
}: UseAllServicesParams) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (!corpId || !recruiterId || !isUseMasterData) return;
    let prevVersion: Record<string, string> = {};

    try {
      prevVersion = JSON.parse(localStorage.getItem("channelVersion") || "{}");
    } catch {
      prevVersion = {};
    }
    const isVersionChanged =
      JSON.stringify(prevVersion) !== JSON.stringify(version);

    const fetchServices = async () => {
      setLoading(true);
      try {
        const baseServer = extractBaseServerV2(window.location.host);
        let allServicesUrl = `${middleware || MIDDLEWARE}${
          ENDPOINTS.allServices
        }`;
        const response = await fetch(allServicesUrl, {
          method: "POST",
          credentials: "include",
          headers: {
            ...API_HEADERS,
            baseserver: baseServer,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            corp_id: corpId,
            recruiter_id: recruiterId,
            request_type: "v4InventoryCheck",
          }),
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }

        const result = await response.json();
        setData(result);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (isVersionChanged) {
      fetchServices();
    }
  }, [corpId, recruiterId, version, isUseMasterData]);

  return { data, loading, error };
};
